export default "/_next/static/images/product--bell-legacy-6b24037e7e5ff7d05219cd7f4e512d40.svg";